import { DataView } from "primereact/dataview";
import React, { useEffect, useState } from "react";
import { downloadOutil, getOutils } from "../../../service/ScrbService";
import { setCursorDefault, setCursorProgress } from "../ScrbTools";
import { I18n } from "aws-amplify";
import { Skeleton } from "primereact/skeleton";

export default function Outils() {

    const [outils, setOutils] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);

    useEffect(() => {
        getOutils().then(setOutils);
    }, []);

    const downloadFile = (key) => {
        setCursorProgress();
        setIsDownloading(true);
        downloadOutil(key).then((file) => {
            let link = document.createElement('a');
            link.href = file.headers.Location;
            link.download = file.headers.Filename;
            link.click();
            setCursorDefault();
            setIsDownloading(false);
        });
    }

    const listTemplate = (outils) => {
        return <div className="flex flex-wrap w-full column-gap-4 row-gap-4">
            {outils.map(outil => {
                const fileName = I18n.get(outil.metadata.filename);
                const title = <span><i className={`fa-light fa-file-${outil.metadata.icon}`} style={{ fontSize: "2rem", color: 'green' }}></i> <div className='pt-3 text-sm'>{fileName}</div></span>;
                const hoverCss = !isDownloading ? "hover:bg-blue-100" : "";
                return <button
                    key={outil.key}
                    className={`border-1 border-round-xl border-300 w-20rem h-8rem bg-white ${hoverCss}`}
                    style={{ boxShadow: "0 0 0px 0 #395697", cursor: 'pointer' }}
                    onClick={() => downloadFile(outil.key.split('/').pop())}
                    disabled={isDownloading}
                >
                    {title}
                </button>
            })}
        </div>;
    }

    return outils.length > 0 ?
        <div>
            <div className="text-xl pb-2">{I18n.get("downloads")} :</div>
            {<DataView value={outils} listTemplate={listTemplate} />}
        </div> :
        <div className="flex flex-column lg:flex-row flex-wrap gap-3">
            {[...Array(3)].map((_, index) => (
                <Skeleton key={index} width="20rem" height="10rem" />
            ))}
        </div>;
}
